import "../../../chunk-FDX44TNG.js";
import { useContext as useReactContext } from "react";
function useSafeContext(context, name) {
  const ctx = useReactContext(context);
  if (ctx === void 0) {
    throw new Error(`must be inside a ${name} provider.`);
  }
  return ctx;
}
export {
  useSafeContext
};
//# sourceMappingURL=useSafeContext.js.map